import { render, staticRenderFns } from "./PlacementGroupPersons.vue?vue&type=template&id=21b188a6&"
import script from "./PlacementGroupPersons.vue?vue&type=script&lang=ts&"
export * from "./PlacementGroupPersons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports